import { apiConstructor as api } from '@/api/apiConstructor';
import { Category } from '@/types/categories';
import { AxiosResponse } from 'axios';

export async function getCategory(id: string): Promise<any> {
  const response: AxiosResponse = await api.get(`categories/${id}`);
  return response.data;
}

export async function getCategories(): Promise<any> {
  try {
    const response: AxiosResponse = await api.get('categories');
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function getLayouts(): Promise<any> {
  try {
    const response: AxiosResponse = await api.get('layouts');
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function saveCategory(category: Category): Promise<Category> {
  const url: string =
    category.id === undefined ? 'categories' : `categories/${category.id}`;

  try {
    const response: AxiosResponse =
      category.id === undefined
        ? await api.post(url, { ...category })
        : await api.put(url, { ...category });
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function saveCategoryOrder(sortOrder: any[]): Promise<void> {
  await api.put('categories/resort', {
    ...sortOrder,
  });
}
